import { Card, Modal, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { menuItems } from "../../helpers/MenuList";
const { Paragraph, Text } = Typography;
function SmallScreenNav({ open, onClose }) {
  const navigate = useNavigate();
  const gridStyle = {
    width: "50%",
  };

  return (
    <Modal
      onCancel={onClose}
      style={{ marginTop: "-90px" }}
      open={open}
      footer={null}
      title={null}
      closable={false}
    >
      <Typography.Paragraph>
        <CloseOutlined onClick={onClose} />
      </Typography.Paragraph>
      <Card>
        {menuItems.map((item) => (
          <Card.Grid
            key={item.label}
            style={gridStyle}
            onClick={() => {
              navigate(`${item.path}`);
              onClose();
            }}
          >
            <Paragraph style={{ textAlign: "center" }}>
              <Text style={{ fontSize: "25px" }}>{item.icon}</Text>
              <br />
              <Text style={{ color: "#888" }}>{item.label}</Text>
            </Paragraph>
          </Card.Grid>
        ))}
      </Card>
    </Modal>
  );
}

export default SmallScreenNav;
